import { render, staticRenderFns } from "./CfdiPerceptionDeductionType.vue?vue&type=template&id=5d53eaa8"
import script from "./CfdiPerceptionDeductionType.vue?vue&type=script&lang=js"
export * from "./CfdiPerceptionDeductionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d53eaa8')) {
      api.createRecord('5d53eaa8', component.options)
    } else {
      api.reload('5d53eaa8', component.options)
    }
    module.hot.accept("./CfdiPerceptionDeductionType.vue?vue&type=template&id=5d53eaa8", function () {
      api.rerender('5d53eaa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/CfdiPerceptionDeductionType.vue"
export default component.exports